import { render } from "./RequestOverview.vue?vue&type=template&id=b3cb997e&scoped=true"
import script from "./RequestOverview.vue?vue&type=script&lang=js"
export * from "./RequestOverview.vue?vue&type=script&lang=js"

import "./RequestOverview.vue?vue&type=style&index=0&id=b3cb997e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DimmyMarcelissen\\WebstormProjects\\dividenduitkering\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3cb997e"]])

export default __exports__